var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"text-capitalize",class:_vm.htmlClass,staticStyle:{"background-color":"white","color":"black"},on:{"click":_vm.toggleAboutUsForm}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-information-outline")]),_c('span',[_vm._v("About Us")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }